import { createAction } from 'redux-actions';
import {
  ajaxGet,
  ajaxPost,
  ajaxPut,
  formPost,
  httpActions,
} from '@figure/frontlib-onboarding-redux';

const { baseUrl } = httpActions;
const SECURE = `${baseUrl()}/service-application-pl/secure/api/v1/application`;
const SECUREV2 = `${baseUrl()}/service-application-pl/secure/api/v2/application`;
const EXTERNALV2 = `${baseUrl()}/service-application-pl/external/api/v1/application`;
const SECUREV3 = `${baseUrl()}/service-application-pl/secure/api/v3/application`;

export const ACTIVATE_PERSONAL_LOAN = 'PL::ACTIVATE_PERSONA_LOAN';
export const CREATE_PERSONAL_LOAN = 'PL::CREATE_PERSONAL_LOAN';
export const SAVE_PERSONAL_LOAN = 'PL::SAVE_PERSONAL_LOAN';
export const SAVE_PROPERTY = 'PL::SAVE_PROPERTY';
export const SAVE_CONSENT = 'PL::SAVE_CONSENT';
export const SAVE_CONSENT_LIST = 'PL::SAVE_CONSENT_LIST';
export const SAVE_MANUAL_PAYSTUB_DATA = 'PL::SAVE_MANUAL_PAYSTUB_DATA';
export const UPDATE_PERSONAL_LOAN = 'PL::UPDATE_PERSONAL_LOAN';
export const GET_PERSONAL_LOAN_CONSENT_TYPES = 'PL::GET_PERSONAL_LOAN_CONSENT_TYPES';
export const GET_PERSONAL_LOAN = 'PL::GET_PERSONAL_LOAN';
export const GET_ACTIVE_PERSONAL_LOAN = 'PL::GET_ACTIVE_PERSONAL_LOAN';
export const GET_USER_PERSONAL_LOANS = 'PL::GET_USER_PERSONAL_LOANS';
export const GET_ELIGIBLE_STATES = 'PL::GET_ELIGIBLE_STATES';
export const GET_INELIGIBLE_ZIP_CODES = 'PL::GET_INELIGIBLE_ZIP_CODES';
export const UPLOAD_DOCUMENT = 'PL::UPLOAD_DOCUMENT';
export const SAVE_DISBURSE_ACH = 'PL::SAVE_DISBURSE_ACH';
export const SAVE_DISBURSE_ACH_PLAID = 'PL::SAVE_DISBURSE_ACH_PLAID';
export const SAVE_AUTOPAY_ACH = 'PL::SAVE_AUTOPAY_ACH';
export const SAVE_INCOME_SOURCE = 'PL::SAVE_INCOME_SOURCE';
export const GIACT_ACCOUNT_VERIFICATION = 'PL::GIACT_ACCOUNT_VERIFICATION';
export const SEND_EMPLOYER_VERIFICATION = 'PL::SEND_EMPLOYER_VERIFICATION';
export const SAVE_FROZEN_PIN = 'PL:SAVE_FROZEN_PIN';

export const activatePersonalLoan = createAction(ACTIVATE_PERSONAL_LOAN);

export const getPersonalLoanConsentTypes = () => async (dispatch) =>
  ajaxGet(GET_PERSONAL_LOAN_CONSENT_TYPES, dispatch, `${SECURE}/consent-types`);
export const getPersonalLoan = (uuid) => async (dispatch) =>
  ajaxGet(GET_PERSONAL_LOAN, dispatch, `${SECURE}/pl/${uuid}`);
export const getActivePersonalLoan = () => async (dispatch) =>
  ajaxGet(GET_ACTIVE_PERSONAL_LOAN, dispatch, `${SECURE}/pl/active`);
export const getUserPersonalLoans = () => async (dispatch) =>
  ajaxGet(GET_USER_PERSONAL_LOANS, dispatch, `${SECURE}/all`);
export const savePersonalLoan = (data) => async (dispatch) =>
  ajaxPost(SAVE_PERSONAL_LOAN, dispatch, `${SECURE}/pl`, data);

export const createPersonalLoanApplication = () => async (dispatch) =>
  ajaxPost(CREATE_PERSONAL_LOAN, dispatch, `${EXTERNALV2}/pl `);
/**
 * savePersonalLoanV2 was added to account for 'state' verification on the backend when starting a new PL.
 */
export const savePersonalLoanV2 = (data, state) => async (dispatch) =>
  ajaxPost(SAVE_PERSONAL_LOAN, dispatch, `${SECUREV2}/pl?state=${state}`, data);
export const saveProperty = (data) => async (dispatch) =>
  ajaxPut(SAVE_PROPERTY, dispatch, `${SECURE}/property`, data);
export const saveConsent = (data) => async (dispatch) =>
  ajaxPut(SAVE_CONSENT, dispatch, `${SECURE}/consent`, data);
export const saveConsents = (data) => async (dispatch) =>
  ajaxPut(SAVE_CONSENT_LIST, dispatch, `${SECURE}/consent-list`, data);
export const updatePersonalLoan = (uuid, data) => async (dispatch) =>
  ajaxPut(UPDATE_PERSONAL_LOAN, dispatch, `${SECURE}/pl/${uuid}`, data);
export const updatePersonalLoanv3 = (data) => async (dispatch) =>
  ajaxPost(UPDATE_PERSONAL_LOAN, dispatch, `${SECUREV3}/pl`, data);
export const uploadDocument = (data, onProgress) => async (dispatch) => {
  const form = new FormData();
  form.append('uuid', data.uuid);
  form.append('type', data.type);
  form.append('file', data.file);
  if (data.countryCode) form.append('countryCode', data.countryCode);

  return formPost(
    UPLOAD_DOCUMENT,
    dispatch,
    `${SECURE}/pl/${data.uuid}/upload`,
    form,
    data,
    onProgress
  );
};
export const saveManualPaystubData = (data) => async (dispatch) =>
  ajaxPut(SAVE_MANUAL_PAYSTUB_DATA, dispatch, `${SECURE}/pl/manual-paystub`, data);

/**
 * Saves updated account and routing numbers for a disbursement account.  This is used in the event that we didn't get the fully
 * qualified account or routing number from Plaid and need to allow the user to update it manually.
 * @param {Object} data Updated ACH data object including keys:
 *   - {String} helocUuid: The UUID for the HELOC application to update.
 *   - {String} accountNumber: The updated ACH account number (must match last four of existing masked account number).
 *   - {String} routingNumber: The updated ACH routing number.
 *   - {String} achAccountId: The Plaid account ID.
 */
export const saveDisburseAch = (data) => async (dispatch) =>
  ajaxPut(SAVE_DISBURSE_ACH, dispatch, `${SECURE}/pl/ach`, data);
export const saveDisburseAchPlaid = (data) => async (dispatch) =>
  ajaxPut(SAVE_DISBURSE_ACH_PLAID, dispatch, `${SECURE}/pl/ach/plaid`, data);
export const saveAutopayAch = (data) => async (dispatch) =>
  ajaxPut(SAVE_AUTOPAY_ACH, dispatch, `${SECURE}/pl/ach/autopay`, data);
export const giactAccountVerification = (data) => async (dispatch) =>
  ajaxPut(GIACT_ACCOUNT_VERIFICATION, dispatch, `${SECURE}/pl/ach/giact`, data);
export const sendEmployerVerification = (data) => async (dispatch) =>
  ajaxPut(SEND_EMPLOYER_VERIFICATION, dispatch, `${SECURE}/pl/employee-verification`, data);
export const saveFrozenPin = (data) => async (dispatch) =>
  ajaxPut(SAVE_FROZEN_PIN, dispatch, `${SECURE}/pl/frozen-pin`, data);
